<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="24">
              <a-form-item label="片区选择">
                <a-tree-select :tree-data="zoneTreeData" v-model="query.deviceId" style="width: 100%"
                  :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                  :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search
                  treeNodeFilterProp="title"></a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="downloadTemplate">下载模板</a-button>
              <a-upload name="file" :multiple="false" @change="changeFile" :file-list="fileList"
                :customRequest="customRequest">
                <a-button type="primary" style="margin-left: 12px" :loading="importLoading">批量导入</a-button>
              </a-upload>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table ref="table" rowKey="id" :columns="columns"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :data-source="list"
        :pagination="pagination" @change="pageChange" bordered>
        <span slot="action" slot-scope="text, record">
          <a @click="Handle(record.id)">编辑</a>
        </span>
        <span slot="openState" slot-scope="text">
          <a-tag color="#f12b35" v-if="text == 0">不开启</a-tag>
          <a-tag color="rgb(50, 205, 50)" v-else>开启</a-tag>
        </span>
        <span slot="arithmeticPattern" slot-scope="text">
          <a-tag color="#1890ff" v-if="text == 0" style="border-radius: 10px; padding: 0 15px; border-style: dashed;">手动设置</a-tag>
          <a-tag color="#722ed1" v-else-if="text == 1" style="border-radius: 10px; padding: 0 15px; border-style: dashed;">双轨预警算法beta</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="pmtName" slot-scope="text">
        夜间流量报警 
        </span>
      </a-table>
      <a-modal :title="!currentId ? '新增' : '编辑'" width="50%" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
        <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="分区选择">
            <a-tree-select :tree-data="zoneTreeData"
              v-decorator="['deviceId', { rules: [{ required: true, message: '请选择分区名称' }] }]" style="width: 100%"
              :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
              tree-default-expand-all show-search treeNodeFilterProp="title" @change="onZoneChange"></a-tree-select>
          </a-form-item>
          <a-form-item label="算法模式选择">
            <a-checkbox-group
              v-if="!currentId"
              v-decorator="['arithmeticPattern', { rules: [{ required: true, type: 'array', message: '请选择算法模式' }] }]"
              style="width: 100%">
              <a-checkbox :value="0" :disabled="patternState === 1 || patternState === 3">手动设置</a-checkbox>
              <a-checkbox :value="1" :disabled="patternState === 0 || patternState === 3">双轨预警算法beta</a-checkbox>
            </a-checkbox-group>
            <a-radio-group
              v-else
              v-decorator="['arithmeticPattern', { rules: [{ required: true, message: '请选择算法模式' }] }]"
              :disabled="true"
              style="width: 100%">
              <a-radio :value="0">手动设置</a-radio>
              <a-radio :value="1">双轨预警算法beta</a-radio>
            </a-radio-group>
            <div v-if="patternState === 3" class="pattern-state-tip">该片区已配置手动和双轨两种算法模式，无法新增</div>
          </a-form-item>
          <a-form-item label="是否开启报警">
            <a-radio-group v-decorator="['openState', { initialValue: 1, rules: [{ required: true }] }]"
              style="width: 100%">
              <a-radio :value="1">开启</a-radio>
              <a-radio :value="0">不开启</a-radio>
            </a-radio-group>
          </a-form-item>
          <template v-if="showManualFields()">
            <a-form-item label="报警值最大值">
              <a-input v-decorator="['alarmValueMax', { rules: [{ required: true, message: '请输入报警值最大值!' }] }]" />
            </a-form-item>

            <a-form-item label="预警值最大值">
              <a-input v-decorator="['earlyValueMax', { rules: [{ required: true, message: '请输入预警值最大值!' }] }]" />
            </a-form-item>
            <a-form-item label="预警值最小值">
              <a-input v-decorator="['earlyValueMin', { rules: [{ required: true, message: '请输入预警值最小值!' }] }]" />
            </a-form-item>

            <a-form-item label="报警值最小值">
              <a-input v-decorator="['alarmValueMin', { rules: [{ required: true, message: '请输入报警值最小值!' }] }]" />
            </a-form-item>

            <span style="text-align: center; display: block; color: #e01414">报警最大值 > 预警最大值 > 预警最小值 > 报警最小值</span>
          </template>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      currentId: '',
      isUpdate: false,
      disabled: false,
      patternState: null,
      equipmentList: [],
      parameterList: [
        { title: '夜间流量报警', key: '1512346469213470726' },
      ],
      queryUrl: '/pipe-network/alarm_tsl_configs/page',
      modifyUrl: '/pipe-network/alarm_pmt_configs',
      addOrUpdateUrl: '/pipe-network/alarm_tsl_configs',
      deleteUrl: '/pipe-network/alarm_tsl_configs',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      queryOneUrl: '/pipe-network/alarm_tsl_configs',
      visible: false,
      confirmLoading: false,
      list: [],
      zoneTreeData: [],
      typelist: ['加压设备', '加药设备', '其它设备'],
      importLoading: false,
      fileList: [],
      query: {
        deviceType: '',
        deviceNo: '',
        deviceName: '',
        pmtName: '',
        tenantId: this.$store.state.user.info.tenantId,
        sysType: '分区'
      },
      columns: [
        {
          title: '分区名称',
          dataIndex: 'deviceName'
        },
        {
          title: '报警类型',
          dataIndex: 'pmtName',
          scopedSlots: { customRender: 'pmtName' }
        },
        {
          title: '是否开启报警',
          dataIndex: 'openState',
          scopedSlots: { customRender: 'openState' }
        },
        {
          title: '算法模式',
          dataIndex: 'arithmeticPattern',
          scopedSlots: { customRender: 'arithmeticPattern' }
        },
        {
          title: '报警最小值',
          dataIndex: 'alarmValueMin'
        },
        {
          title: '预警最小值',
          dataIndex: 'earlyValueMin'
        },
        {
          title: '报警最大值',
          dataIndex: 'alarmValueMax'
        },
        {
          title: '预警最大值',
          dataIndex: 'earlyValueMax'
        },
        {
          title: '更改时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      treeDefaultExpandedKeys: [],
    }
  },
  mounted() {
    this.queryList()
  },
  created() {
    this.equipmentSelect()
    this.resetList()
    this.getZoneData()
    this.queryList()
  },
  watch: {
    zoneTreeData (val) {
      this.chuli(val)
    }
  },
  methods: {
    chuli (n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.title = item.zoneName
          item.children = this.chuli(item.children)
          if (item.level == 1 ) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    equipmentSelect() {
      this.$http.get('/pipe-network/water_works_devices/list').then((res) => { 
        const list = []
        res.data.map((item) => {
          list.push({
            title: item.deviceName,
            key: item.id
          })
        })
        this.equipmentList = list
      })
    }, 
    Handle(id) {
      this.disabled = true
      this.addOrUpdateHandle(id)
    },
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    onZoneChange(zoneId) {
      if (!zoneId) {
        this.patternState = null
        return
      }
      this.$http.get('/smart-water-pipe-network/alarm_tsl_configs/zone/pattern-state', { params: { zoneId } })
        .then(({ data }) => {
          this.patternState = data
          // 自动勾选所有可选的算法模式
          let next = []
          if (this.patternState === 0 || this.patternState === 2) {
            next.push(0)
          }
          if (this.patternState === 1 || this.patternState === 2) {
            next.push(1)
          }
          this.addOrUpdateForm.setFieldsValue({ arithmeticPattern: next })
        })
        .catch(() => {
          this.patternState = null
        })
    },
    addOrUpdateHandle(id) {
      this.isUpdate = !!id
      this.currentId = id || ''
      this.patternState = null
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.$http.get(`${this.queryOneUrl}/${id}`).then(({ data }) => {
          // 先设置一遍，确保 arithmeticPattern 这种控制显隐的字段先生效
          this.addOrUpdateForm.setFieldsValue({
            deviceId: data.deviceId,
            arithmeticPattern: data.arithmeticPattern,
            openState: data.openState
          })
          // 在下一帧，当报警值相关的输入框显示出来后再进行全量赋值
          this.$nextTick(() => {
            this.addOrUpdateForm.setFieldsValue(data)
          })
        })
      } else {
        this.$nextTick(() => {
          let defaultPattern = [0]
          if (this.patternState === 0) {
            defaultPattern = [0]
          } else if (this.patternState === 1) {
            defaultPattern = [1]
          } else if (this.patternState === 2) {
            defaultPattern = [0, 1]
          } else if (this.patternState === 3) {
            defaultPattern = []
          }
          this.addOrUpdateForm.setFieldsValue({
            arithmeticPattern: defaultPattern,
            openState: 1
          })
        })
      }
    },
    showManualFields() {
      const arithmeticPattern = this.addOrUpdateForm.getFieldValue('arithmeticPattern')
      if (Array.isArray(arithmeticPattern)) {
        return arithmeticPattern.includes(0)
      }
      return arithmeticPattern === 0
    },
    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          Object.keys(values).forEach(key => {
            if (typeof values[key] === 'string') {
              values[key] = values[key].trim()
            }
          })
          
          const params = {
            id: this.currentId,
            pmtId: "1512346469213470726",
            sysType: '分区',
            ...values,
          }
          if (!this.currentId) {
            const selectedPatterns = Array.isArray(values.arithmeticPattern) ? values.arithmeticPattern : []
            params.arithmeticPattern = selectedPatterns.includes(0) ? 0 : 1
            const hasManual = selectedPatterns.includes(0)
            const hasDualTrack = selectedPatterns.includes(1)
            if (hasManual && hasDualTrack) {
              params.alsoSaveDualTrack = true
            }
          }

          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    handleCancel(e) {
      this.addOrUpdateVisible = false
      this.disabled = false
      this.addOrUpdateForm.resetFields()
    },
    downloadTemplate() {
      const token = storage.get(ACCESS_TOKEN)
      axios({
        url: process.env.VUE_APP_API_BASE_URL + 'pipe-network/alarm_tsl_configs/null/export',
        method: 'get',
        responseType: 'blob',
        headers: {
          Authorization: token
        }
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '夜间流量报警导入模板.xlsx'
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
        this.$message.success('模板下载成功')
      }).catch(err => {
        this.$message.error('模板下载失败')
      })
    },
    changeFile(info) {
      this.fileList = info.fileList
    },
    customRequest(info) {
      this.importLoading = true
      const formData = new FormData()
      formData.append('file', info.file)
      axios.post(`${process.env.VUE_APP_API_BASE_URL}pipe-network/alarm_tsl_configs/list/import/export`, formData, {
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        },
        responseType: 'blob'
      })
        .then(response => {
          const blob = response.data
          if (blob.size == 0) {
            this.$message.success('导入成功')
          } else {
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `夜间流量报警导入结果_${new Date().getTime()}.xlsx`
            link.click()
            window.URL.revokeObjectURL(url)
            this.$message.warning('导入成功,但有错误数据,请查看')
          }
        })
        .catch(error => {
          this.$message.error('导入失败')
        })
        .finally(() => {
          this.queryList()
          this.importLoading = false
          this.fileList = []
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/ .ant-table-thead>tr>th {
  text-align: center;
}
/deep/ .ant-table-tbody>tr>td {
  text-align: center;
}

.pattern-state-tip {
  color: #faad14;
  font-size: 13px;
  margin-top: 4px;
}
</style>
